<template>
    <div>
        <div class="top-text">
            <van-sticky>
                <van-nav-bar @click-left="handelBack" :border="false">
                    <template #title>
                        <!-- <span :class="{ ug: language == 'ug' }">{{ $t('直播学院视频') }}</span> -->
                    </template>
                    <template #left>
                        <img src="@/assets/icon_back.png" alt="" />
                    </template>
                </van-nav-bar>
            </van-sticky>
        </div>
        <div class="content">
            <iframe class="iframe" :src="iframeSrc" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            language: '',
            iframeSrc: 'https://www.xiaohongshu.com/discovery/item/6594d4cd00000000110329f3?source=webshare&xhsshare=pc_web&xsec_token=ABhhuCDNCLPslegXwrMRlCB46cmVd2U4RY1QyAopb8p9g=&xsec_source=pc_share'
        }
    },
    created() {
        const data = this.$route.query.language
        this.language = data
        this.iframeSrc = this.$route.query.src
        this.getLanguage(data)
    },
    methods: {
        getLanguage(language) {
            this.$i18n.locale = language
        },
        handelBack() {
            this.$router.go(-1)
        }
    },
}
</script>

<style lang="scss" scoped>
.top-text {
    position: fixed;
    width: 375px;
    height: 44px;
    z-index: 9;
    top: 0px;
}

::v-deep .van-nav-bar__content {
    height: 44px;
}

.van-nav-bar__left img {
    width: 30px;
    height: 30px;
}

.van-nav-bar__title span {
    font-family: 'UKIJCJK';
    font-size: 18px;
    font-weight: bold;
}

.van-nav-bar__right span {
    font-size: 16px;
}

.content {
    width: 100vw;
    height: 100vh;
    padding-top: 44px;
    box-sizing: border-box;
    .iframe {
        width: 100%;
        height: 100%;
    }
}
</style>